export const CONTACT_EMAIL = "Kaigalb30@gmail.com";
export const LAST_UPDATED = "October 23, 2026";
